import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { isTelegramMiniApp } from "@/shared/lib/telegram";
import { isMaxMiniApp } from "@/shared/lib/max";
/**
 * Tags `<html data-app="miniapp|web">` so CSS can branch on the runtime
 * environment. (Previously also hosted the Mantine theme + modals providers;
 * Mantine has since been fully removed.)
 */
export const AppEnvProvider = ({ children }) => {
    const isMiniApp = isTelegramMiniApp() || isMaxMiniApp();
    useEffect(() => {
        const html = document.documentElement;
        html.setAttribute("data-app", isMiniApp ? "miniapp" : "web");
        return () => {
            html.removeAttribute("data-app");
        };
    }, [isMiniApp]);
    return _jsx(_Fragment, { children: children });
};
